// extracted by mini-css-extract-plugin
export default {"Hero":"Hero_Hero__cro5t","HeroTextWrapper":"Hero_HeroTextWrapper__fIkqI"};